export interface ISimpleLibrary { [key: string]: string; }

export enum DROPUP_STATE_VALUES {
  INITIAL_SCREEN = 'INITIAL_SCREEN',
  SELECT_DESTINATION = 'SELECT_DESTINATION',
  SHOW_ALL_HUBS = 'SHOW_ALL_HUBS',
  SHOW_ONE_HUB = 'SHOW_ONE_HUB',
  SELECT_DEFAULT_HUB = 'SELECT_DEFAULT_HUB',
}

export interface IDropupParams {
  hasButton: boolean;
  hiddenInClose: boolean;
  openInHalf: boolean;
  dropUpColor: string;
}

export interface IDropupStates {
  [key: string]: DROPUP_STATE_VALUES;
}
